/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Survey_ConfirmationInputs */

const sv_page_survey_confirmation = /** @type {(inputs: Page_Survey_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p>Tack för din feedback.</p>`)
};

const en_page_survey_confirmation = /** @type {(inputs: Page_Survey_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<p>Thank you for your feedback.</p>`)
};

/**
* | output |
* | --- |
* | "<p>Thank you for your feedback.</p>" |
*
* @param {Page_Survey_ConfirmationInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_survey_confirmation = /** @type {((inputs?: Page_Survey_ConfirmationInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Survey_ConfirmationInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_survey_confirmation(inputs)
	return en_page_survey_confirmation(inputs)
});